<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

    page: {
        title: 'Новый канал коммуникаций',
        meta: [{ name: 'description', content: appConfig.description }],
    },

    components: { Layout, PageHeader, Multiselect },

    data() {
        return {
            title: 'Новый канал коммуникаций',
            items: [],
            channel_uuid: '',
            name: '',
            code: '',
            trackBy: 'id',
            initStatus: [],
            status: null,
            status_options: [
                {id: 'active', name: 'Активен'},
                {id: 'wait', name: 'Ожидает активации'},
                {id: 'disabled', name: 'Отключен'},
            ],
            action: null,
            initAction: [],
            actions_options: [],
            fl_onlyone: false,
            fl_default: false,
            public: false
        }
    },

    watch: {
        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        },
        initAction: {
            immediate: true,
            handler(values) {
                this.action = this.actions_options.filter(x => values.includes(x[this.trackBy]));
                this.action = this.action[0];
            }
        }
    },

    computed: {
        channel_item(){
            return this.$store.getters['channels/GET_CHANNELS_ITEM'];
        },
        actions_list_data(){
            return this.$store.getters['actions/GET_ACTIONS_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
    },

    async mounted() {
        this.channel_uuid = this.$route.params.channel_uuid ? this.$route.params.channel_uuid : '';

        await this.$store.dispatch('actions/FETCH_ACTIONS_LIST', {});
        this.actions_options = this.actions_list_data;

        if(this.channel_uuid !== ''){

            this.title = 'Настройка канала коммуникаций';
            document.title = appConfig.title + ' - ' + 'Настройка канала коммуникаций';

            let data_send = {
                'uuid' : this.channel_uuid
            }

            await this.$store.dispatch('channels/FETCH_CHANNELS_ITEM', data_send);

            this.name = this.channel_item.name ? this.channel_item.name : '';
            this.code = this.channel_item.code ? this.channel_item.code : '';
            this.fl_onlyone = this.channel_item.fl_onlyone ? this.channel_item.fl_onlyone : '';
            this.fl_default = this.channel_item.fl_default ? this.channel_item.fl_default : '';

            this.public = this.channel_item.access === 'public' ? true : false;

            this.status = this.channel_item.status ? this.channel_item.status : '';
            this.initStatus = [this.status];

            this.action = this.channel_item.action_id ? this.channel_item.action_id : null;
            if (this.action !== null) {
                this.initAction = [this.action];
            }
        }
    },

    methods: {

        async saveItem(){

            let fl_onlyone = 'false';
            let fl_default = 'false';

            if(this.fl_onlyone === true){
                fl_onlyone = 'true';
            }
            if(this.fl_default === true){
                fl_default = 'true';
            }

            let data_send = {
                'name' : this.name,
                'code' : this.code,
                'fl_onlyone' : fl_onlyone,
                'fl_default' : fl_default,
                'access'     : this.public === true ? 'public' : null,
                'action_id'  : this.action && this.action.id ? this.action.id : null,
                'status'     : this.status && this.status.id ? this.status.id : null,
            };

            let result = '';

            if(this.channel_uuid === ''){
                result = await this.$store.dispatch('channels/FETCH_CHANNELS_CREATE', data_send);
            } else {
                data_send.uuid = this.channel_uuid;
                result = await this.$store.dispatch('channels/FETCH_CHANNELS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Channels'});
            }
        }
    },
}

</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Код"
                                        label-for="code"
                                    >
                                        <b-form-input
                                            id="code"
                                            v-model="code"
                                            placeholder="Укажите код канала"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Название канала"
                                        label-for="name"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                            placeholder="Укажите название канала коммуникаций"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Основная функция"
                                        label-for="action"
                                    >
                                        <multiselect
                                            id="action"
                                            :track-by="trackBy"
                                            v-model="action"
                                            :options="actions_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Статус"
                                        label-for="status"
                                    >
                                        <multiselect
                                            id="status"
                                            :track-by="trackBy"
                                            v-model="status"
                                            :options="status_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>
                                    
                                    <b-form-checkbox v-model="fl_onlyone" name="fl_onlyone" style="margin-top: 15px; margin-bottom: 15px" switch>
                                        Разовое подключение к одному боту
                                    </b-form-checkbox>

                                    <b-form-checkbox v-model="fl_default" name="fl_default" style="margin-top: 15px; margin-bottom: 15px" switch>
                                        Подключать по умолчанию
                                    </b-form-checkbox>

                                    <b-form-checkbox v-model="public" name="fl_default" style="margin-top: 15px; margin-bottom: 15px" switch>
                                        В публичном доступе
                                    </b-form-checkbox>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
    </Layout>
</template>
